import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {TopPerformersWidgetFetchHandler} from "./top-performers-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {LineupsClickEventHandler} from "../../../core/handlers/lineups.click-event.handler";
import {TopPerformersWidgetAnalyticsDisplayHandler} from "./top-performers-widget.analytics-display.handler";
import {FullGamePopulateDataHandler} from "../../../core/handlers/full-game.populate-data.handler";

export class TopPerformersWidgetHandlers extends HandlerList {

  static injectables = [
    TopPerformersWidgetFetchHandler,
    TopPerformersWidgetAnalyticsDisplayHandler,
    TimingHandler,
    FullGamePopulateDataHandler,
    LineupsClickEventHandler
  ];

  constructor(
    templateWidgetFetchHandler: TopPerformersWidgetFetchHandler,
    topPerformersWidgetAnalyticsDisplayHandler: TopPerformersWidgetAnalyticsDisplayHandler,
    timingHandler: TimingHandler,
    fullGamePopulateDataHandler: FullGamePopulateDataHandler,
    lineupsClickEventHandler: LineupsClickEventHandler,
  ) {
    super();

    [
      templateWidgetFetchHandler,
      topPerformersWidgetAnalyticsDisplayHandler,
      timingHandler,
      fullGamePopulateDataHandler,
      lineupsClickEventHandler
    ].forEach(handler => this.add(handler));
  }
}
